<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section aria-labelledby="ch1" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="Chap-Title-ct" id="ch1"><span aria-label="1" id="pg_1" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch1" title="Link target outside of Sample">DISTRICT OF COLUMBIA POLICE DEPARTMENT DISPATCH CENTER, WASHINGTON, D.C.</span></span></h1>
</header>
<p class="CO">The radio crackled in D.C. Police Department dispatcher Karla Haskell’s headphones. “This is Officer 2026 checking in. All’s quiet on the southern front.”</p>
<p class="Text-Standard-tx">Karla’s cheeks warmed hearing Officer Frankie Graham’s voice.</p>
<p class="Text-Standard-tx">“Evening, Frankie, I copy.” She tried to sound casual but they’d been talking more and more while he was out on foot patrol. Officers were only required to check in once midshift, but he’d called in a lot more than that lately. And last night he’d practically left his radio channel open. They’d chatted for hours between her steady stream of check-ins.</p>
<p class="Text-Standard-tx">She could hear his soft footfalls and slightly labored breath. Walking night patrol in late December was a rough gig even in the best weather and it had been snowing on and off all day. She glanced at the clock. Not even nine thirty yet. It would be a long, cold night out there.</p>
<p class="Text-Standard-tx">“It’s cold enough to freeze the balls off a brass monkey out here.” Frankie paused. “I mean, excuse my bad language.”</p>
<p class="Text-Standard-tx">She let out a breathy laugh. “I’ve been a police dispatcher for nineteen years, Frankie. In my world, brass monkey balls don’t qualify as bad language.”</p>
<p class="Text-Standard-tx"><span aria-label="2" id="pg_2" role="doc-pagebreak">He chuckled. “Well, thank goodness for that. Hang on, I might have me a graffiti artist here.”</span></p>
<p class="Text-Standard-tx">“Where you at?” Karla shifted back into work mode.</p>
<p class="Text-Standard-tx">“I’m at Constitution and 22nd. Looks like he’s defacing the Einstein Memorial. Let me run him off really quick. You mind holding on? There’s something I’d like to ask…”</p>
<p class="Text-Standard-tx">“I’m not going anywhere.” Karla was glad he couldn’t see the red flush climbing up her neck. Frankie might not look like Patrick Swayze, but his toothy smile was genuine and he had a reputation as a good guy around the precinct. Plus, Karla hadn’t been on a date in years.</p>
<p class="Text-Standard-tx">“Hey, buddy,” Frankie called out.</p>
<p class="Text-Standard-tx">There was a long silence, then a sharp inhale. “What the—” Frankie said loudly.</p>
<p class="Text-Standard-tx">Karla could hear the alarm in his voice. The sharp <i>crack</i> of a gunshot made her whole body jolt.</p>
<p class="Text-Standard-tx">Frankie let out a cry so visceral that the hair on her arms stood up.</p>
<p class="Text-Standard-tx">“Frankie? Frankie?” she screamed into her mic.</p>
<p class="Text-Standard-tx">A crash followed by a ragged howl sucked the breath from Karla’s chest. Heart pounding, she listened with horror to a series of wet grunts. After an intolerable few seconds of nothing, she could just barely hear the faint sound of someone singing in the distance.</p>
<p class="Text-Standard-tx">The soft atonal chant made her shudder.</p>
<p class="Text-Standard-tx">As she shouted, “10-33, officer down!” Frankie’s radio went silent.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?53b1ca61